/**
 * useImagePublish — CUADRO NEGRO División Pragmática App.js (rev12 unificado)
 *
 * 🟥 ACTUALIZADO 2026-06-29: Este hook era la FUENTE REAL de
 * `latestWorkspaceImage` que App.js pasaba como prop a Dashboard. Tenía
 * su propio `useState(null)` y su propio listener, lo que sobre-escribía
 * cualquier store global (Dashboard recibía el null desde acá y mi
 * Provider quedaba ignorado).
 *
 * Ahora delega 100% al `WorkspaceImageProvider` (Context global montado
 * a nivel App). Mantenemos la firma `{ latestWorkspaceImage,
 * setLatestWorkspaceImage }` para compatibilidad con App.js — sigue
 * pasando esos props a Dashboard, pero ahora apuntan al store unificado
 * que también consumen Mobile y cualquier futuro layout.
 *
 * Resultado: una sola fuente de verdad, listener único global,
 * persistencia automática en sessionStorage, cero re-mounts perdiendo
 * el estado.
 */
import { useWorkspaceImageStore } from '../../context/WorkspaceImageContext';

export default function useImagePublish() {
  const { latestWorkspaceImage, setLatestWorkspaceImage } = useWorkspaceImageStore();

  return {
    latestWorkspaceImage,
    setLatestWorkspaceImage,
  };
}
